import { render, staticRenderFns } from "./appendix-transfer.vue?vue&type=template&id=315627c2&scoped=true"
import script from "./appendix-transfer.vue?vue&type=script&lang=js"
export * from "./appendix-transfer.vue?vue&type=script&lang=js"
import style0 from "./appendix-transfer.vue?vue&type=style&index=0&id=315627c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315627c2",
  null
  
)

export default component.exports